export default __webpack_public_path__ + "static/summer-sale-banner-e915d6bc28fb21434062fa2831bb22d9.png";